import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location } from '@angular/common';

import { ProjectService } from '../shared/services/project.service';
import { IProject } from '../shared/models/IProject';

@Component({
  selector: 'app-project-detail',
  templateUrl: './project-detail.component.html',
  styleUrls: ['./project-detail.component.scss']
})
export class ProjectDetailComponent implements OnInit {

  public project: IProject;

  constructor(
    private route: ActivatedRoute,
    private location: Location,
    private _projectsService: ProjectService ) { }

  ngOnInit() {
     const id = this.route.snapshot.params['id'];
     this._projectsService.getProjects(1).subscribe(
      data => {
        this.project = data.find(m => m.id === id);
      },
      err => console.error(err),
      () => console.log('completed')
     );
  }

}



// WEBPACK FOOTER //
// C:/Users/phildp/ahs/gdm/code/madebygdm/src/app/projects/project-detail/project-detail.component.ts